import { render } from "./EventDialogForm.vue?vue&type=template&id=cb9c84f6&scoped=true"
import script from "./EventDialogForm.vue?vue&type=script&lang=js"
export * from "./EventDialogForm.vue?vue&type=script&lang=js"

import "./EventDialogForm.vue?vue&type=style&index=0&id=cb9c84f6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb9c84f6"]])

export default __exports__